// @ts-nocheck — Phase 2 file, not active in MVP. Type errors suppressed intentionally.
import { User, AuthMethod } from '@inventory/core';
import { BasePouchDBAdapter } from './BasePouchDBAdapter';

interface UserDocument extends PouchDocument {
  username: string;
  email: string;
  hashedPassword: string;
  role: string;
  active: boolean;
  createdAt: string;
  updatedAt: string;
}

export class UserPouchDBAdapter extends BasePouchDBAdapter<User> {
  constructor(dbName: string) {
    super(dbName, 'user');
  }

  protected async toDocument(user: User): Promise<UserDocument> {
    return {
      _id: user.id,
      type: 'user',
      username: user.username,
      email: user.email,
      hashedPassword: user.passwordHash,
      role: user.role,
      active: user.active,
      createdAt: user.createdAt.toISOString(),
      updatedAt: user.updatedAt.toISOString()
    };
  }

  protected fromDocument(doc: UserDocument): User {
    return {
      id: doc._id,
      username: doc.username,
      email: doc.email,
      passwordHash: doc.hashedPassword,
      role: doc.role as any,
      active: doc.active,
      createdAt: new Date(doc.createdAt),
      updatedAt: new Date(doc.updatedAt),
      permissions: [],
      authMethods: [AuthMethod.PASSWORD],
      failedAttempts: 0,
      locked: false,
      lastLogin: undefined
    };
  }

  async save(user: User): Promise<void> {
    const doc = await this.toDocument(user);
    try {
      const existing = await this.db.get(doc._id);
      await this.db.put({ ...doc, _rev: (existing as any)._rev });
    } catch (error) {
      if ((error as any).status === 404) {
        await this.db.put(doc);
      } else {
        throw this.handleError(error as any);
      }
    }
  }

  async delete(id: string): Promise<void> {
    try {
      const doc = await this.db.get(id);
      await this.db.remove(doc as any);
    } catch (error) {
      if ((error as any).status !== 404) throw this.handleError(error as any);
    }
  }

  async findByUsername(username: string): Promise<User | null> {
    const users = await this.query({ username });
    return users[0] ?? null;
  }

  async findByEmail(email: string): Promise<User | null> {
    const users = await this.query({ email });
    return users[0] ?? null;
  }
}